import LeadsBulkUpload from "../../../views/LeadsBulkUpload";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const LeadsBulkUploadRoutes = [
  {
    path: "/leads-bulk-upload",
    component: LeadsBulkUpload,
    exact: true,
    menuName: MenuNames.LEADS_BULK_UPLOAD,
  },
];

export default LeadsBulkUploadRoutes;
